// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_CHANNELS: '/content/channels',
  CONTENT_LANGUAGES: '/content/languages',
  CONTENT_CATEGORIES: '/content/categories',
  CONTENT_VIDEOS: '/content/videos',
  CONTENT_ADS: '/content/ads',
  CONTENT_CATEGORIES_SEQUENCE: '/content/categories/:slug/sequence',
  CONTENT_TABS: '/content/tabs',
  ADMIN_USERS: '/users',
  REPORTS_OVERVIEW_VIDEOS: '/reports/overview/videos',
  REPORTS_OVERVIEW_ADS: '/reports/overview/ads',
  REPORTS_ENGAGEMENT: '/reports/engagement',
  CONTACTS: '/contacts',
  RESOURCES: '/resources',
  BULK_EMAIL: '/bulk-email',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
